import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-12 mb-md-25" }
const _hoisted_7 = { class: "border border-primary mb-10" }
const _hoisted_8 = {
  class: "d-flex align-items-center justify-content-between fw-bold p-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_9 = { class: "col-md-7" }
const _hoisted_10 = { class: "fs-4 text-white" }
const _hoisted_11 = { class: "col-md-5" }
const _hoisted_12 = { class: "d-flex float-end" }
const _hoisted_13 = { class: "col-md-3 mb-2" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_17 = { class: "col-md-2 mb-2" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = { class: "col-md-2 mb-2" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_24 = { class: "col-md-2 mb-2" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = { class: "col-md-2 mb-2" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "col-md-1 mb-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "col-md-12 mt-3" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un mouvement")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "mouvementForm",
        onSubmit: _ctx.addMouvement,
        "validation-schema": _ctx.mouvementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Magasin ", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.magasinOptions,
                  searchable: true,
                  "track-by": "label",
                  label: "label",
                  modelValue: _ctx.magasin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.magasin) = $event)),
                  placeholder: "Sélectionner le magasin",
                  onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMag(_ctx.magasin)))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.magasinss? _ctx.magasinss:"Magasin"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRowMouvement()))
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                        _createTextVNode(" Ajouter un produit ")
                      ]), 2),
                      _createVNode(_component_router_link, { to: "/liste-mouvements" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row gx-2 p-2 d-flex align-items-center justify-content-between mt-10" }, [
                    _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Produit "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Type Operation"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Quantité "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Motif "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Reférence "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-1" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Actions")
                    ])
                  ], -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouvements, (mouvement, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row gx-2 px-2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_Multiselect, {
                            "close-on-select": true,
                            options: _ctx.produitOptions,
                            searchable: true,
                            disabled: _ctx.isDis,
                            multiple: false,
                            modelValue: mouvement.proCondiMagInventaire,
                            "onUpdate:modelValue": ($event: any) => ((mouvement.proCondiMagInventaire) = $event),
                            placeholder: "Sélectionner les produits"
                          }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"]),
                          (_ctx.valideteRowMouvement(mouvement.proCondiMagInventaire))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                            : _createCommentVNode("", true),
                          (_ctx.validateDupliacat(mouvement.proCondiMagInventaire))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Ce produit a été déjà selectionné"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_Multiselect, {
                            searchable: true,
                            options: _ctx.lestypes,
                            modelValue: mouvement.typeOperation,
                            "onUpdate:modelValue": ($event: any) => ((mouvement.typeOperation) = $event),
                            placeholder: "Choisir"
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                          (_ctx.valideteRowMouvement(mouvement.typeOperation))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((mouvement.qte) = $event),
                            type: "number",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "saisir qte"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, mouvement.qte]
                          ]),
                          (_ctx.valideteRowMouvement(mouvement.qte))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, " La quantité est obligatoire. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.motifSuiviOptions,
                            searchable: true,
                            modelValue: mouvement.motifsSuivi,
                            "onUpdate:modelValue": ($event: any) => ((mouvement.motifsSuivi) = $event),
                            placeholder: "Choisir"
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                          (_ctx.valideteRowMouvement(mouvement.motifsSuivi))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Le motif est obligatoire"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((mouvement.refMov) = $event),
                            type: "text",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Reférence"
                          }, null, 8, _hoisted_29), [
                            [_vModelText, mouvement.refMov]
                          ]),
                          (_ctx.valideteRowMouvement(mouvement.refMov))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, " La référence est obligatoire "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeRowMouvement(index))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                        ]), 8, _hoisted_32)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter un mouvement ", 8, _hoisted_35),
                _createVNode(_component_router_link, {
                  to: "/inventaires/liste-mouvements",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}